import { render, staticRenderFns } from "./comp_EnglishSongSection.vue?vue&type=template&id=9bba8e9c&"
import script from "./comp_EnglishSongSection.vue?vue&type=script&lang=js&"
export * from "./comp_EnglishSongSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports